var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlickGridFold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ribbon/\u5176\u4ED6/\u6536\u8D77") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ribbon\\u56FE\\u6807",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 16,
    transform: "translate(-892, -981)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ribbon/\\u5176\\u4ED6/\\u6536\\u8D77",
    transform: "translate(892.9661, 985)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u77E9\\u5F62",
    points: "-4.96125313e-13 5 5.033893 5 2.5169465 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD",
    transform: "translate(2.5169, 1.5) scale(1, -1) translate(-2.5169, -1.5)",
    points: "-4.96125313e-13 6.99440506e-14 5.033893 6.99440506e-14 2.5169465 3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-10",
    x: 6.033893,
    y: 1,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-12",
    x: 6.033893,
    y: 6,
    width: 8,
    height: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlickGridFold);
export default __webpack_public_path__ + "static/media/slickGridFold.6637f1d2.svg";
export { ForwardRef as ReactComponent };